'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	(0, _jquery2.default)(this).find('a[data-confirm], button[data-confirm]').click(function () {
		var $a = (0, _jquery2.default)(this);
		var confirmed = $a.data('confirmed');
		if (!confirmed) {
			_message2.default.confirm($a.attr('data-confirm'), $a.attr('data-confirm-title')).then(function () {
				$a.data('confirmed', true);
				setTimeout(function () {
					$a.get(0).click();
				}, 0);
			}).catch(function () {});
			return false;
		} else {
			$a.data('confirmed', false);
		}
		return true;
	});
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _message = require('../message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

; /**
   * Adds support for confirm dialogs defined by data-confirm and optionally by data-confirm-title.
   * This is global initializer, it is initialized only on page load, not subsequently.
   *
   * Usage:
   * <a href="/api/DeleteProduct/5" data-confirm="Common:ConfirmProductDelete" data-confirm-title="Common:ConfirmDeleteTitle">Delete product</a>
   */


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/confirm.js
// module id = 493
// module chunks = 0